interface DepartamentoInfo {
  imagen: string;
}

const departamentos: Record<string, DepartamentoInfo> = {
  "01": {
    imagen: "/uploads/departamentos/01.webp",
  },
  "02": {
    imagen: "/uploads/departamentos/02.webp",
  },
  "03": {
    imagen: "/uploads/departamentos/03.webp",
  },
  "04": {
    imagen: "/uploads/departamentos/04.webp",
  },
  "05": {
    imagen: "/uploads/departamentos/05.webp",
  },
  "06": {
    imagen: "/uploads/departamentos/06.webp",
  },
  "07": {
    imagen: "/uploads/departamentos/07.webp",
  },
  "08": {
    imagen: "/uploads/departamentos/08.webp",
  },
  "09": {
    imagen: "/uploads/departamentos/09.webp",
  },
  "10": {
    imagen: "/uploads/departamentos/10.webp",
  },
  "11": {
    imagen: "/uploads/departamentos/11.webp",
  },
  "12-A": {
    imagen: "/uploads/departamentos/12a.webp",
  },
  "12-B": {
    imagen: "/uploads/departamentos/12b.webp",
  },
  "14": {
    imagen: "/uploads/departamentos/14.webp",
  },
  "15": {
    imagen: "/uploads/departamentos/15.webp",
  },
  "16": {
    imagen: "/uploads/departamentos/16.webp",
  },
  "17": {
    imagen: "/uploads/departamentos/17.webp",
  },
  "18": {
    imagen: "/uploads/departamentos/18.webp",
  },
  "19": {
    imagen: "/uploads/departamentos/19.webp",
  },
  "20": {
    imagen: "/uploads/departamentos/20.webp",
  },
  "21": {
    imagen: "/uploads/departamentos/21.webp",
  },
  "22": {
    imagen: "/uploads/departamentos/22.webp",
  },
  "23": {
    imagen: "/uploads/departamentos/23.webp",
  },
  "24": {
    imagen: "/uploads/departamentos/24.webp",
  },
  "25": {
    imagen: "/uploads/departamentos/25.webp",
  },
  "26": {
    imagen: "/uploads/departamentos/26.webp",
  },
  "27": {
    imagen: "/uploads/departamentos/27.webp",
  },
};

export const _getDepartamentoInfo = (
  codigo: string
): DepartamentoInfo | undefined => {
  // Si el código es un número del 1 al 9, agregar el 0 al inicio
  const codigoFormateado = codigo.length === 1 ? `0${codigo}` : codigo;

  // Manejar el caso especial de los departamentos 12A y 12B
  if (codigoFormateado === "12A" || codigoFormateado === "12B") {
    return departamentos[`12-${codigoFormateado.slice(-1)}`];
  }

  return departamentos[codigoFormateado];
};
